export function getImgSrc(contentUrl: string, src: string) {
  return `${contentUrl}json/${src}`;
}
